(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reels-video-section"] && !Shopify.designMode) return;
  try {
    
  function initAllReelsSections() {
    var sections = document.querySelectorAll('[data-reels-section-id]');

    sections.forEach(function (section) {
      if (section.dataset.reelsInit === 'true') return;

      var scroller = section.querySelector('.reel-video-list');
      var prevButton = section.querySelector('.reel-nav--prev');
      var nextButton = section.querySelector('.reel-nav--next');

      if (!scroller || !prevButton || !nextButton) return;

      var firstCard = scroller.querySelector('.reel-video-card');

      function getScrollAmount() {
        if (firstCard) {
          var rect = firstCard.getBoundingClientRect();
          var cardWidth = rect.width;
          var gap = 24; // matches CSS gap on desktop
          return cardWidth + gap;
        }
        return scroller.clientWidth || 0;
      }

      function scrollByAmount(direction) {
        var amount = getScrollAmount() * direction;
        var newLeft = scroller.scrollLeft + amount;
        if (typeof scroller.scrollTo === 'function') {
          scroller.scrollTo({ left: newLeft, behavior: 'smooth' });
        } else {
          scroller.scrollLeft = newLeft;
        }
      }

      prevButton.addEventListener('click', function () {
        scrollByAmount(-1);
      });

      nextButton.addEventListener('click', function () {
        scrollByAmount(1);
      });

      section.dataset.reelsInit = 'true';
    });
  }

  // Initialize immediately in case DOMContentLoaded has already fired
  initAllReelsSections();

  document.addEventListener('DOMContentLoaded', initAllReelsSections);
  document.addEventListener('shopify:section:load', initAllReelsSections);

  } catch(e) { console.error(e); }
})();
})();
